/*
 * gy-facets.js — mobile filter bottom-sheet behaviour.
 *
 * 1. Keeps every filter group expanded. The sheet flattens groups to show their
 *    chips inline, but (a) facets.js re-renders the markup on apply and (b) the
 *    theme strips the `open` attribute from <details> when the sheet closes. On
 *    iOS, a closed <details> hides its content regardless of CSS, so the chips
 *    vanish on reopen. We watch both node and `open`-attribute changes and
 *    re-open the groups so they always render.
 * 2. Close by tapping the backdrop or dragging the sheet down (the visible X is
 *    removed in CSS — these gestures are intuitive enough).
 */
(function () {
  'use strict';

  function openAll() {
    var groups = document.querySelectorAll('.mobile-facets__details');
    for (var i = 0; i < groups.length; i++) {
      if (!groups[i].hasAttribute('open')) groups[i].setAttribute('open', '');
    }
  }

  function closeSheet(wrapper) {
    var summary = wrapper.querySelector('.mobile-facets__disclosure > summary');
    if (summary) summary.click(); // triggers the theme's close
  }

  function init() {
    var wrapper = document.querySelector('.mobile-facets__wrapper');
    if (!wrapper) return;

    openAll();

    // Re-open on re-render (childList) and whenever `open` is stripped (attributes).
    var observer = new MutationObserver(function () { openAll(); });
    observer.observe(wrapper, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['open']
    });

    // Tap the backdrop (anywhere outside the panel) to close.
    var form = wrapper.querySelector('.mobile-facets');
    if (form) {
      form.addEventListener('click', function (e) {
        if (!e.target.closest('.mobile-facets__inner')) closeSheet(wrapper);
      });
    }

    // Drag the sheet down to close.
    var inner = wrapper.querySelector('.mobile-facets__inner');
    if (inner) {
      var startY = null;
      inner.addEventListener(
        'touchstart',
        function (e) {
          startY = inner.scrollTop <= 0 ? e.touches[0].clientY : null;
        },
        { passive: true }
      );
      inner.addEventListener(
        'touchmove',
        function (e) {
          if (startY === null) return;
          if (e.touches[0].clientY - startY > 90) {
            startY = null;
            closeSheet(wrapper);
          }
        },
        { passive: true }
      );
    }
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
